// extracted by mini-css-extract-plugin
export default {"content":"Content__content___j5NR6"};